// import React from 'react';
// import { BrowserRouter, Routes, Route } from 'react-router-dom';
// import Homepage from './pages/Homepage';


// const App = () => {
//   return (
 
//     <BrowserRouter>
//       <Routes>
//         <Route path="/" element={<Homepage />} />
//       </Routes>
//     </BrowserRouter>
 
//   );
// };

// export default App;



import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Homepage from './pages/Homepage';
import SuccessPage from './pages/SuccessPage';
import CanceledPage from './pages/CanceledPage';
 
const App = () => {
  return (
    <BrowserRouter>
    <meta name="AI Readiness & Digital Maturity Index" content="AI Readiness & Digital Maturity Assessment is a tool that helps organizations to assess their AI readiness and digital maturity. It provides a comprehensive report with recommendations to improve the AI readiness and digital maturity of the organization." />
      <Routes>
        <Route path="/" element={<Homepage />} />
        <Route path="/successpage" element={<SuccessPage />} />
        <Route path="/canceledpage" element={<CanceledPage />} />
      </Routes>
    </BrowserRouter>
  );
};
 
export default App;
 

